import UserCard from "../../admin/UserCard";

function CreateMemberInfo(props) {
  return (
    <div className="row round-box mt-30">
      <div className="col-12">
        <div className="row">
          <div className="col-12 mb-30">
            <h5 className="sub-title">조합직원등록</h5>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12">
            <div className="form-group">
              <label className="form-control-label">아이디</label>
              <input
                id="_userid"
                name="userid"
                type="text"
                className="form-control"
                maxLength="25"
                value={props.newAccount.userid || ""}
                onChange={props.newHandleChange}
              />
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12">
            <div className="form-group">
              <label className="form-control-label">이름</label>
              <input
                id="_username"
                name="username"
                type="text"
                className="form-control"
                maxLength="25"
                value={props.newAccount.username || ""}
                onChange={props.newHandleChange}
              />
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12">
            <div className="form-group">
              <label className="form-control-label">휴대전화번호</label>
              <input
                type="text"
                id="_hp"
                name="hp"
                className="form-control"
                maxLength="11"
                data-type="int"
                value={props.newAccount.hp || ""}
                onChange={props.newHandleChange}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="form-group">
              <label className="form-control-label">비밀번호</label>
              <input
                type="password"
                id="_passwd"
                name="passwd"
                className="form-control"
                maxLength="20"
                value={props.newAccount.passwd || ""}
                onChange={props.newHandleChange}
              />
            </div>
          </div>
        </div>

        <div className="row pt-20 pb-5">
          <div className="col-12 text-center">
            <span
              className="btn btn-main btn-icon btn-round-full"
              onClick={props.fnCreateClick}
            >
              저장
            </span>
          </div>
        </div>

        <UserCard
          users={props.users}
          setUsers={props.setUsers}
          fnUserSaveClick={props.fnUserSaveClick}
          fnUserDeleteClick={props.fnUserDeleteClick}
        />
      </div>
    </div>
  );
}

export default CreateMemberInfo;
